import React, { useState } from 'react';
import { FaBars, FaTimes } from 'react-icons/fa';

export default function Header() {
  const [menuOpen, setMenuOpen] = useState(false);

  const toggleMenu = () => {
    setMenuOpen(!menuOpen);
  };

  const closeMenu = () => {
    setMenuOpen(false);
  };

  const scrollTo = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
    closeMenu();
  };

  return (
    <header>
      <div className="header-container">
        <div className="logo">🏆 Rudra Sports</div>

        {/* Desktop Navigation */}
        <nav style={{ display: 'flex', gap: '2rem', alignItems: 'center' }}>
          <span onClick={() => scrollTo('hero')} style={{ color: 'white', cursor: 'pointer', fontWeight: 500, transition: 'all 0.3s ease' }}>Home</span>
          <span onClick={() => scrollTo('facilities')} style={{ color: 'white', cursor: 'pointer', fontWeight: 500, transition: 'all 0.3s ease' }}>Facilities</span>
          <span onClick={() => scrollTo('pricing')} style={{ color: 'white', cursor: 'pointer', fontWeight: 500, transition: 'all 0.3s ease' }}>Pricing</span>
          <span onClick={() => scrollTo('events')} style={{ color: 'white', cursor: 'pointer', fontWeight: 500, transition: 'all 0.3s ease' }}>Events</span>
          <span onClick={() => scrollTo('about')} style={{ color: 'white', cursor: 'pointer', fontWeight: 500, transition: 'all 0.3s ease' }}>About</span>
          <span onClick={() => scrollTo('contact')} style={{ color: 'white', cursor: 'pointer', fontWeight: 500, transition: 'all 0.3s ease' }}>Contact</span>
        </nav>

        {/* Mobile Menu Button */}
        <button 
          onClick={toggleMenu}
          style={{
            background: 'none',
            border: 'none',
            color: 'white',
            fontSize: '1.5rem',
            cursor: 'pointer',
            display: 'none'
          }}
          className="mobile-menu-btn"
        >
          {menuOpen ? <FaTimes /> : <FaBars />}
        </button>
      </div>

      {/* Mobile Navigation */}
      {menuOpen && (
        <nav style={{
          display: 'flex',
          flexDirection: 'column',
          background: 'rgba(0, 78, 137, 0.95)',
          padding: '1rem',
          gap: '0.5rem'
        }}>
          <span onClick={() => scrollTo('hero')} style={{ padding: '0.5rem', color: 'white', cursor: 'pointer' }}>Home</span>
          <span onClick={() => scrollTo('facilities')} style={{ padding: '0.5rem', color: 'white', cursor: 'pointer' }}>Facilities</span>
          <span onClick={() => scrollTo('pricing')} style={{ padding: '0.5rem', color: 'white', cursor: 'pointer' }}>Pricing</span>
          <span onClick={() => scrollTo('events')} style={{ padding: '0.5rem', color: 'white', cursor: 'pointer' }}>Events</span>
          <span onClick={() => scrollTo('about')} style={{ padding: '0.5rem', color: 'white', cursor: 'pointer' }}>About</span>
          <span onClick={() => scrollTo('contact')} style={{ padding: '0.5rem', color: 'white', cursor: 'pointer' }}>Contact</span>
        </nav>
      )}

      <style>{`
        @media (max-width: 768px) {
          nav {
            display: none !important;
          }
          .mobile-menu-btn {
            display: block !important;
          }
        }
      `}</style>
    </header>
  );
}
